import * as request from "@/utils/request";

export default {
	//开户-查询地区列表
	get_qxy_tax_get_area(data) {
		return request.post("/paas/ets/get_area", data);
	},
	//开户-查询账号信息
	get_qxy_tax_get_account_info(data) {
		return request.post("/paas/ets/get_account_info", data);
	},
	//开户-订购+注册(原型中的"下一步")
	get_qxy_tax_register(data) {
		return request.post("/paas/ets/register", data);
	},
	//开户-检验密码
	get_qxy_tax_check_password(data) {
		return request.post("/paas/ets/check_password", data);
	},
	//获取个税缴纳链接地址
	get_qxy_pay_tax_getUrl(data) {
		return request.post("/paas/ets/third_withdraw", data);
	},
	//服务商列表
	get_qxy_declare_channel_list(data) {
		return request.post("/paas/qxy_declare_tax/channel_list", data);
	},
	//服务商公司人员列表
	get_qxy_declare_channel_company_list(data) {
		return request.post("/paas/qxy_declare_tax/channel_company_list", data);
	},
	//一键申报
	get_qxy_declare_declare_submit(data) {
		return request.post("/paas/ets/declare_submit", data);
	},
	//一键作废
	get_qxy_declare_declare_cancel(data) {
		return request.post("/paas/ets/declare_cancel", data);
	},
	//一键更正
	get_qxy_declare_declare_update(data) {
		return request.post("/paas/ets/declare_update", data);
	},
	//服务类型
	get_category_list(data) {
		return request.get("/paas/category/category_list", data);
	},
	//查看详情
	get_qxy_declare_tax_declare_view(data) {
		return request.post("/paas/qxy_declare_tax/declare_view", data);
	},
	//开户-查询开户列表
	get_qxy_tax_get_account_list(data) {
		return request.post("/paas/ets/get_account_list", data);
	},
	//导出申报人员记录
	get_qxy_tax_export_declare_employee(data) {
		return request.get("/paas/declareemployee/export", data);
	},
	//导出申报人员收入记录
	get_qxy_tax_export_declare_income(data) {
		return request.post("/paas/declare/export", data);
	},
	//身份信息报送表列表
	get_qxy_tax_identity_info_list(data) {
		return request.get("/paas/etsEmployeeInfo/platform", data);
	},
	// 人员信息采集列表
	get_etsEmployeeInfoList(data) {
		return request.get("/paas/etsEmployeeInfo/list", data);
	},
	// 人员信息报送
	post_etsEmployeeInfo_declare(data) {
		return request.post("/paas/etsEmployeeInfo/declare", data);
	},
	// 人员信息报送作废
	post_etsEmployeeInfo_cancel(data) {
		return request.post("/paas/etsEmployeeInfo/cancel", data);
	},
	//收入信息报送表列表
	get_qxy_tax_income_info_list(data) {
		return request.post("/paas/ets/income_apply_list", data);
	},
	//扣缴端劳务报酬所得数据列表
	get_qxy_tax_payment_list_list(data) {
		return request.post("/paas/ets/tax_payment_list", data);
	},
	// 下载完税证明
	get_qxy_tax_certificate_list(data) {
		return request.post("/paas/ets/download_tax_cert", data, {
			responseType: "blob",
		});
	},
	//获取第三方账号列表
	get_qxy_pay_tax_third_party_account_list(data) {
		return request.post("/paas/ets/third_list", data);
	},
};
